import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { installClientLogForwarder } from './logging/installClientLogForwarder'

// NOTE: React.StrictMode is currently disabled so dev matches production behaviour for demos

installClientLogForwarder()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)

reportWebVitals()
